export const convertNumberToCurrency = (number = 0): string => {
  const value = number.toString();
  let lastThreeDigits = value.substring(value.length - 3);
  const remainingDigits = value.substring(0, value.length - 3);

  if (remainingDigits !== '') lastThreeDigits = ',' + lastThreeDigits;
  const amount =
    remainingDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThreeDigits;
  return amount;
};

export const formateINRtoAmount = (formattedINR: string): number => {
  try {
    const numberString = formattedINR.replace(/₹|,/g, '');

    const parsedNumber = parseFloat(numberString);

    if (isNaN(parsedNumber)) {
      console.error('Invalid INR format', formattedINR);
      return NaN;
    }

    return parsedNumber;
  } catch (e) {
    console.error(e);
    return NaN;
  }
};

export interface ConvertNumberToLocaleCurrencyObjectTypes {
  maximumFractionDigits?: number;
  currency?: string;
  style?: 'decimal' | 'currency' | 'percent';
  minimumFractionDigits?: number;
}

export const convertNumberToLocaleCurrency = (
  number = 0,
  locale = 'en-IN',
  options: ConvertNumberToLocaleCurrencyObjectTypes = {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    currency: 'INR',
    style: 'currency'
  }
): string => {
  return number.toLocaleString(locale, { ...options });
};
